<qa-countdown-wrapper>
  <div [@countdown]="currentNumber" class="countdown">
    @for (number of numbers; track $index) { @if (number === currentNumber) {
    <div class="number">
      {{ number }}
    </div>
    } }
    <svg height="216" width="216">
      <circle
        [attr.r]="radius"
        cx="108"
        cy="108"
        fill="transparent"
        stroke-width="9"
        class="default-arc"
      />
      <circle
        [style.strokeDasharray]="circumference"
        [style.strokeDashoffset]="dashoffset"
        [attr.r]="radius"
        cx="108"
        cy="108"
        fill="transparent"
        stroke-width="9"
      />
    </svg>
  </div>
  <div class="ready-text">{{ 'common.ready' | translate }} ?</div>
</qa-countdown-wrapper>
